import React, { Component } from 'react';

// @mui/material components

import CircularProgress from '@mui/material/CircularProgress';

// @mui/icons-material
import InsertDriveFile from "@mui/icons-material/InsertDriveFile";

// core components
import Grid from "@mui/material/Grid";

import OthelloBotonera from '../componentsothello/OthelloBotonera.jsx';
import OthelloComboBox from '../componentsothello/OthelloComboBox.jsx';
import OthelloEdit from '../componentsothello/OthelloEdit.jsx';

import ImageUpload from "../components/ImageUpload.jsx";
import { ModelosOficina, TiposOficina, OpcionSiNo, LimiteProximidad, Roles, PopUpResult, OpcionTipoMapa, ModoReport, TiposModeloCerradura } from "../othelloConstantes.jsx";
import { ImprimirListado } from '../othelloFunciones.jsx';

import { DataStatePage } from "../othelloConstantes.jsx";

import OthelloPopUpResult from "../componentsothello/OthelloPopUpResult.jsx";
import OthelloTitulo from "../componentsothello/OthelloTitulo.jsx";
import OthelloTituloPanelData from '../componentsothello/OthelloTituloPanelData.jsx';
import MDTypography from '../components/MDTypography/index.js';

// style for this view

export default function Oficina({ ...props }) {

    const { literal, idRol } = props;

    const [loading, setLoading] = React.useState(true);
    const [statePage, setstatePage] = React.useState(DataStatePage.dsEdit);
    const [id_oficina, setid_oficina] = React.useState(0);
    const [dataoficina, setdataoficina] = React.useState(null);

    const [alert, setalert] = React.useState(null);

    React.useEffect(() => {
        getDataPage();
    }, [loading]);

    //METODOS GLOBALES DE LA PAGINA

    const getDataPage = () => {

        fetch('api/Data/GetOficinaVirtual')
            .then(response => response.json())
            .then(data => {
                setdataoficina(data);
                setid_oficina(data.id_Oficina)
                setLoading(false);
            }).catch(error => {
                setdataoficina(null);
                setid_oficina(-1)
                setLoading(false);
            });
    }

    const getDataVacia = () => {

        fetch('api/Data/GetOficinaVirtualVacia')
            .then(response => response.json())
            .then(data => {
                setdataoficina(data);
                setid_oficina(data.id_Oficina)
                setLoading(false);
            }).catch(error => {
                setdataoficina(null);
                setid_oficina(-1)
                setLoading(false);
            });
    }

    const grabarDataPage = (event) => {

        //Obtengo los datos        
        let formulario = document.getElementById('formoficina');
        let data = new FormData(formulario);

        //AÑADO LA PARTE DE LA CONFIGURACION DE MAIL
        var jsonData = JSON.stringify({
            descripcion: document.getElementById("descripcionCorreo").value,
            dISPLAYNAME: document.getElementById("displayCorreo").value,
            eMAIL: document.getElementById("emailCorreo").value,
            mAILHOST: document.getElementById("mailhostCorreo").value,
            mailUser: document.getElementById("mailuserCorreo").value,
            mailPass: document.getElementById("mailpassCorreo").value,
            puerto: parseInt(document.getElementById("puertoCorreo").value, 0),
            sSL: document.getElementById("sslCorreo").value
        });

        //AÑADO LA PARTE DE LA CONFIGURACION DE Cerradura
        var jsonDataCerradura = JSON.stringify({
            modelo: document.getElementById("modeloCerradura").value,
            descripcion: document.getElementById("descripcionCerradura").value,
            cerraduraUser: document.getElementById("cerraduraUser").value,
            cerraduraPass: document.getElementById("cerraduraPass").value,  
            cerraduraUrlALternativa: document.getElementById("cerraduraUrlALternativa").value              
        });

        data.append("ConfigEMailNotifica", jsonData);
        data.append("ConfigCerradura", jsonDataCerradura);

        //LLamamo al servicio
        fetch('api/Data/GrabarOficinaVirtual', {
            method: 'POST',
            body: data,

        }).then(response => response.json()).then(data => {
            if (data != null) {
                setdataoficina(data);
                setLoading(true);
                setalert(PopUpResult.OK);
            }
        }).catch(error => {
            setalert(PopUpResult.KO);
        });
    }

    const nuevoDataPage = () => {
        
        getDataVacia();
    }

    const deshacerDataPage = () => {

        setLoading(true);        
    }

    const keyDownDataPage = (id) => {

        if (id != null) {
            //Si estamos con la receta
            if (id == 'volcaroficina')
            {
                VolcarOficina();            
            }
            else if (id == 'volcaroficinaconupdate')
            {
                VolcarOficinaConUpdate();
            }            
        }
    }

    const VolcarOficina = () => {

        var jsonData = JSON.stringify(false);

        fetch('api/Data/ActualizarVersionesOficina', {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
            },
            body: jsonData

        }).then(response => response.json()).then(res => {

            setalert(PopUpResult.Info);
        }).catch(error => {

        });

        getDataPage();
    }

    const VolcarOficinaConUpdate = () => {

        var jsonData = JSON.stringify(true);

        fetch('api/Data/ActualizarVersionesOficina', {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
            },
            body: jsonData

        }).then(response => response.json()).then(res => {

            setalert(PopUpResult.Info);

        }).catch(error => {

        });
    }

    const onClosePopUpResult = () => {

        setalert(null);
    }

    function renderFormOficina(ofi) {

        if (ofi != null) {
            return (
                <form id="formoficina" >
                    <Grid container>
                        <Grid item xs={12} lg={12}>
                            <br />
                            <OthelloTitulo titulo="Datos Generales" />
                        </Grid>
                    </Grid>
                    <Grid container>
                        <input id="id_Oficina" name="id_Oficina" type="hidden" value={ofi.id_Oficina} />
                        <Grid item xs={12} sm={4} lg={2}>
                            <OthelloEdit label="Nombre" fieldname="NombreOficina" currentvalue={ofi.nombreOficina} />
                        </Grid>
                        <Grid item xs={6} sm={4} lg={2}>
                            <OthelloEdit label="Direccion Web ATM" fieldname="UrlWeb" currentvalue={ofi.urlWeb} />
                        </Grid>
                        <Grid item xs={6} sm={4} lg={2}>
                            <OthelloEdit label="Web Corporativa" fieldname="UrlWebCorporativa" currentvalue={ofi.urlWebCorporativa} />
                        </Grid>
                        <Grid item xs={6} sm={4} lg={2}>
                            <OthelloEdit label="Web Reservas" fieldname="UrlWebReservas" currentvalue={ofi.urlWebReservas} />
                        </Grid>
                        <Grid item xs={6} sm={4} lg={2}>
                            <OthelloComboBox label='Skin' fieldname="Id_Interfaz" items={ModelosOficina} currentvalue={ofi.id_Interfaz} />
                        </Grid>
                        <Grid item xs={6} sm={4} lg={2}>
                            <OthelloComboBox label='Tipo' fieldname="TipoOfi" items={TiposOficina} currentvalue={ofi.tipoOfi} />
                        </Grid>
                    </Grid>
                    <Grid container>
                        <Grid item xs={6} sm={4} lg={2}>
                            <OthelloEdit label="E-Mail" fieldname="EMail" currentvalue={ofi.eMail} />
                        </Grid>
                        <Grid item xs={6} sm={4} lg={2}>
                            <OthelloEdit label="Telefono" fieldname="Telefono" currentvalue={ofi.telefono} />
                        </Grid>
                        <Grid item xs={6} sm={2} lg={1}>
                            <OthelloEdit label="Latitud" fieldname="latStringAux" currentvalue={ofi.lat} />
                        </Grid>
                        <Grid item xs={6} sm={2} lg={1}>
                            <OthelloEdit label="Longitud" fieldname="lonStringAux" currentvalue={ofi.lon} />
                        </Grid>
                        <Grid item xs={3} sm={4} lg={2}>
                            <OthelloEdit label="Imgs Portada" fieldname="ImgPortada" currentvalue={ofi.imgPortada} />
                        </Grid>
                        <Grid item xs={5} sm={4} lg={2}>
                            <OthelloComboBox label='Portada MultiSize' fieldname="ImgPortadaMultiSize" items={OpcionSiNo} currentvalue={ofi.imgPortadaMultiSize} />
                        </Grid>
                        <Grid item xs={4} sm={4} lg={2}>
                            <OthelloComboBox label='Baja' fieldname="Baja" items={OpcionSiNo} currentvalue={ofi.baja} />
                        </Grid>
                    </Grid>
                    <Grid container>
                        <Grid item xs={6} sm={4} lg={2}>
                            <OthelloEdit label="Certifcado IOS" fieldname="CertificadoIOS" currentvalue={ofi.certificadoIOS} />
                        </Grid>
                        <Grid item xs={6} sm={4} lg={5}>
                            <OthelloEdit label="Google Play" fieldname="GooglePlay" currentvalue={ofi.googleplay} />
                        </Grid>
                        <Grid item xs={12} sm={4} lg={5}>
                            <OthelloEdit label="Apple Play" fieldname="AppleStore" currentvalue={ofi.applestore} />
                        </Grid>
                    </Grid>
                    <Grid container>
                        <Grid item xs={12} sm={6} md={4}>
                            <OthelloEdit label="Informacion Adicional (Contacto)" fieldname="Descripcion" currentvalue={ofi.descripcion} rows="2" />
                        </Grid>
                        <Grid item xs={12} sm={6} md={4}>
                            <OthelloEdit label="Agradecimientos" fieldname="Agradecimientos" currentvalue={ofi.agradecimientos} rows="2" />
                        </Grid>
                        <Grid item xs={12} sm={6} md={4}>
                            <OthelloEdit label="Equipo" fieldname="Equipo" currentvalue={ofi.equipo} rows={2} />
                        </Grid>
                    </Grid>
                    <Grid container>
                        <Grid item xs={12} sm={6}>
                            <OthelloEdit label="Informacion de uso - Aviso Legal" fieldname="About" currentvalue={ofi.about} rows="3" />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <OthelloEdit label="Politica Privacidad" fieldname="Privacidad" currentvalue={ofi.privacidad} rows="3" />
                        </Grid>
                    </Grid>
                    <Grid container>
                        <Grid item xs={12} sm={4} md={3}>
                            <OthelloEdit label="Cancelacion Reservas" fieldname="CancelacionReservas" currentvalue={ofi.cancelacionReservas} rows="3" />
                        </Grid>
                        <Grid item xs={12} sm={4} md={3}>
                            <OthelloEdit label="Condiciones Reservas" fieldname="CondicionesReservas" currentvalue={ofi.condicionesReservas} rows="3" />
                        </Grid>
                        <Grid item xs={12} sm={4} md={3}>
                            <OthelloEdit label="Cookies Reservas" fieldname="CookiesReservas" currentvalue={ofi.cookiesReservas} rows={3} />
                        </Grid>
                        <Grid item xs={12} sm={4} md={3}>
                            <OthelloEdit label="Privacidad Reservas" fieldname="PrivacidadReservas" currentvalue={ofi.privacidadReservas} rows={3} />
                        </Grid>
                    </Grid>
                    <Grid container>
                        <Grid item xs={12} lg={12}>
                            <br />
                            <OthelloTitulo titulo="Opciones Oficina" />
                        </Grid>
                    </Grid>
                    <Grid container>
                        <Grid item xs={6} sm={4} lg={1}>
                            <OthelloEdit label="Color Principal" fieldname="BackColor" currentvalue={ofi.backColor} />
                        </Grid>
                        <Grid item xs={6} sm={4} lg={2}>
                            <OthelloEdit label="Color Principal Oscuro" fieldname="DarkBackColor" currentvalue={ofi.darkBackColor} />
                        </Grid>
                        <Grid item xs={6} sm={4} lg={2}>
                            <OthelloEdit label="Color Secundario" fieldname="Id_Analitycs" currentvalue={ofi.id_Analitycs} />
                        </Grid>
                        <Grid item xs={6} sm={4} lg={1}>
                            <OthelloEdit label="Color Textos" fieldname="ForeColor" currentvalue={ofi.foreColor} />
                        </Grid>
                        <Grid item xs={6} sm={4} lg={2}>
                            <OthelloComboBox label='Analytics ATM' fieldname="AnalyticsATM" items={OpcionSiNo} currentvalue={ofi.analyticsATM} />
                        </Grid>
                        <Grid item xs={6} sm={4} lg={2}>
                            <OthelloEdit label="Dias Borrar Analitycs" fieldname="DiasDeleteAnalyticsATM" currentvalue={ofi.diasDeleteAnalyticsATM} />
                        </Grid>
                        <Grid item xs={6} sm={4} lg={2}>
                            <OthelloEdit label="Google Analitys" fieldname="Codigo_Analitycs" currentvalue={ofi.codigo_Analitycs} />
                        </Grid>
                    </Grid>
                    <Grid container>
                        <Grid item xs={6} sm={4} lg={2}>
                            <OthelloComboBox label='Con Lector QR' fieldname="ConLectorQR" items={OpcionSiNo} currentvalue={ofi.conLectorQR} />
                        </Grid>
                        <Grid item xs={6} sm={4} lg={2}>
                            <OthelloComboBox label='Mapa en Inicio' fieldname="ConMapa" items={OpcionSiNo} currentvalue={ofi.conMapa} />
                        </Grid>
                        <Grid item xs={6} sm={4} lg={2}>
                            <OthelloComboBox label='Acerca de en Inicio' fieldname="ConAcercaDe" items={OpcionSiNo} currentvalue={ofi.conAcercaDe} />
                        </Grid>
                        <Grid item xs={6} sm={4} lg={2}>
                            <OthelloComboBox label='Limitacion Proximidad' fieldname="LimiteProximidad" items={LimiteProximidad} currentvalue={ofi.limiteProximidad} />
                        </Grid>
                        <Grid item xs={6} sm={4} lg={2}>
                            <OthelloComboBox label='Area Privada' fieldname="AreaPrivada" items={OpcionSiNo} currentvalue={ofi.areaPrivada} />
                        </Grid>
                        <Grid item xs={6} sm={2} lg={1}>
                            <OthelloEdit label="H. Ini Push" fieldname="HoraInicioPush" currentvalue={ofi.horaInicioPush} />
                        </Grid>
                        <Grid item xs={6} sm={2} lg={1}>
                            <OthelloEdit label="H. Fin Push" fieldname="HoraFinPush" currentvalue={ofi.horaFinPush} />
                        </Grid>
                    </Grid>
                    <Grid container>
                        <Grid item xs={6} sm={4} lg={2}>
                            <OthelloComboBox label='Con Agenda Destacada' fieldname="ConAgendaDestacada" items={OpcionSiNo} currentvalue={ofi.conAgendaDestacada} />
                        </Grid>
                        <Grid item xs={6} sm={4} lg={2}>
                            <OthelloEdit label="Dias Borrar Pois Agenda" fieldname="DiasDeleteNews" currentvalue={ofi.diasDeleteNews} />
                        </Grid>
                        <Grid item xs={6} sm={4} lg={2}>
                            <OthelloEdit label="Acceso Rapido 1 (IdArea)" fieldname="QuickBt1" currentvalue={ofi.quickBt1} />
                        </Grid>
                        <Grid item xs={6} sm={4} lg={2}>
                            <OthelloEdit label="Acceso Rapido 2 (IdArea)" fieldname="QuickBt2" currentvalue={ofi.quickBt2} />
                        </Grid>
                        <Grid item xs={6} sm={4} lg={2}>
                            <OthelloEdit label="Acceso Rapido 3 (IdArea)" fieldname="QuickBt3" currentvalue={ofi.quickBt3} />
                        </Grid>
                        <Grid item xs={6} sm={4} lg={2}>
                            <OthelloEdit label="Acceso Rapido 4 (IdArea)" fieldname="QuickBt4" currentvalue={ofi.quickBt4} />
                        </Grid>
                    </Grid>
                    <Grid container>
                        <Grid item xs={12} >
                            <MDTypography variant="caption"  color={"error"} ml={1}>
                                Acceso Rapido 1-2-3-4 si valor es -9 se trata de mostrar la opcion de incidencia en dicha posicion
                            </MDTypography>
                        </Grid>
                    </Grid>
                    <Grid container>
                        <Grid item xs={6} sm={4} lg={2}>
                            <OthelloComboBox label='Acceso Rapido Promos' fieldname="ConQuickPromo" items={OpcionSiNo} currentvalue={ofi.conQuickPromo} />
                        </Grid>
                        <Grid item xs={6} sm={4} lg={2}>
                            <OthelloComboBox label='Con Promos Destacada' fieldname="ConPromosDestacada" items={OpcionSiNo} currentvalue={ofi.conPromosDestacada} />
                        </Grid>
                        <Grid item xs={6} sm={4} lg={2}>
                            <OthelloComboBox label='Promos solo Logados' fieldname="ConPromoSoloRegistrados" items={OpcionSiNo} currentvalue={ofi.conPromoSoloRegistrados} />
                        </Grid>
                        <Grid item xs={4} sm={4} lg={2}>
                            <OthelloComboBox label='PreCheckIn' fieldname="Checkin" items={OpcionSiNo} currentvalue={ofi.checkin} />
                        </Grid>
                        <Grid item xs={6} sm={4} lg={2}>
                            <OthelloEdit label="Mail PreCheckIn" fieldname="Mail_Checkin" currentvalue={ofi.mail_Checkin} />
                        </Grid>
                        <Grid item xs={6} sm={4} lg={2}>
                            <OthelloComboBox label='PopUp Maps' fieldname="PopUpMaps" items={OpcionSiNo} currentvalue={ofi.popUpMaps} />
                        </Grid>
                        <Grid item xs={6} sm={4} lg={2}>
                            <OthelloEdit label='DistanciaPopUpsMaps (En Km-Ej: 0.5)' fieldname="DistanciaPopUpsMapsAux" currentvalue={ofi.distanciaPopUpsMaps} />
                        </Grid>
                        <Grid item xs={6} sm={4} lg={2}>
                            <OthelloComboBox label='Region Modo Maps' fieldname="RegionMaps" items={OpcionSiNo} currentvalue={ofi.regionMaps} />
                        </Grid>
                        <Grid item xs={6} sm={4} lg={2}>
                            <OthelloEdit label="Zoom Region Maps" fieldname="RegionZoomMaps" currentvalue={ofi.regionZoomMaps} />
                        </Grid>
                        <Grid item xs={6} sm={4} lg={2}>
                            <OthelloComboBox label='Tipo Region Maps' fieldname="RegionTipoMaps" items={OpcionTipoMapa} currentvalue={ofi.regionTipoMaps} />
                        </Grid>
                        <Grid item xs={6} sm={4} lg={2}>
                            <OthelloComboBox label='Tipo Mapa Rutas' fieldname="TipoMapRutas" items={OpcionTipoMapa} currentvalue={ofi.tipoMapRutas} />
                        </Grid>
                        <Grid item xs={6} sm={4} lg={2}>
                            <OthelloComboBox label='Como LLegar Personalizado' fieldname="ComoLLegarPersonalizado" items={OpcionSiNo} currentvalue={ofi.comoLLegarPersonalizado} />
                        </Grid>
                        <Grid item xs={6} sm={4} lg={2}>
                            <OthelloEdit label="Color Pintado Rutas" fieldname="ColorPintadoRutas" currentvalue={ofi.colorPintadoRutas} />
                        </Grid>
                    </Grid>
                    <Grid container>
                        <Grid item xs={12} lg={12}>
                            <br />
                            <OthelloTitulo titulo="Incidencias" />
                        </Grid>
                    </Grid>
                    <Grid container>
                        <Grid item xs={6} sm={2} lg={1}>
                            <OthelloComboBox label='Incidencias' fieldname="Incidencias" items={OpcionSiNo} currentvalue={ofi.incidencias} />
                        </Grid>
                        <Grid item xs={6} sm={3} lg={2}>
                            <OthelloEdit label="Nombre Inci." fieldname="NombreIncidencias" currentvalue={ofi.nombreIncidencias} />
                        </Grid>
                        <Grid item xs={6} sm={3} lg={2}>
                            <OthelloEdit label="Mail Incidencias" fieldname="Mail_Incidencias" currentvalue={ofi.mail_Incidencias} />
                        </Grid>
                        <Grid item xs={6} sm={4} lg={7}>
                            <OthelloEdit label="Mensaje Incidencias" fieldname="MensajeIncidencia" currentvalue={ofi.mensajeIncidencia} />
                        </Grid>
                    </Grid>
                    <Grid container>
                        <Grid item xs={12} sm={12}>
                            <OthelloEdit label="Ley Proteccion Incidencias" fieldname="PrivacidadIncidencia" currentvalue={ofi.privacidadIncidencia} rows={2} />
                        </Grid>
                    </Grid>
                    <Grid container>
                        <Grid item xs={12} lg={12}>
                            <br />
                            <OthelloTitulo titulo="Redes Sociales" />
                        </Grid>
                    </Grid>
                    <Grid container>
                        <Grid item xs={6} sm={6} md={3}>
                            <OthelloEdit label="Twitter" fieldname="linkTwitter" currentvalue={ofi.linkTwitter} />
                        </Grid>
                        <Grid item xs={6} sm={6} md={2}>
                            <OthelloEdit label="Facebook" fieldname="linkFacebook" currentvalue={ofi.linkFacebook} />
                        </Grid>
                        <Grid item xs={6} sm={6} md={2}>
                            <OthelloEdit label="Instagram" fieldname="linkInstagram" currentvalue={ofi.linkInstagram} />
                        </Grid>
                        <Grid item xs={6} sm={6} md={2}>
                            <OthelloEdit label="Youtube" fieldname="linkYoutube" currentvalue={ofi.linkYoutube} />
                        </Grid>
                        <Grid item xs={12} sm={6} lg={3}>
                            <OthelloEdit label="RSS" fieldname="RSS" currentvalue={ofi.rss} />
                        </Grid>
                    </Grid>
                    <Grid container>
                        <Grid item xs={12} lg={12}>
                            <br />
                            <OthelloTitulo titulo="SEO" />
                        </Grid>
                    </Grid>
                    <Grid container>
                        <Grid item xs={12}>
                            <OthelloEdit label="Title" fieldname="TitleSEO" currentvalue={ofi.titleSEO} />
                        </Grid>
                        <Grid item xs={12}>
                            <OthelloEdit label="Descripcion" fieldname="DescripcionSEO" currentvalue={ofi.descripcionSEO} rows={3} />
                        </Grid>
                        <Grid item xs={12}>
                            <OthelloEdit label="Keywords" fieldname="KeywordsSEO" currentvalue={ofi.keywordsSEO} rows={3} />
                        </Grid>
                    </Grid>
                    <Grid container>
                        <Grid item xs={12} lg={12}>
                            <br />
                            <OthelloTitulo titulo="Imagenes" />
                        </Grid>
                    </Grid>
                    <Grid container>
                        <Grid item xs={10} sm={5} lg={2}>
                            <br />
                            <p>Imagen Patrocinador</p>
                            <ImageUpload
                                id="ImagePatrocinador" name="ImagePatrocinador"
                                imageUrl={ofi.imagePatrocinador}
                                addButtonProps={{
                                    color: "rose",
                                    round: true
                                }}
                                changeButtonProps={{
                                    color: "rose",
                                    round: true
                                }}
                                removeButtonProps={{
                                    color: "danger",
                                    round: true
                                }}
                            />
                        </Grid>
                        <Grid item xs={10} sm={5} lg={2}>
                            <br />
                            <p>Imagen Reservas</p>
                            <ImageUpload
                                id="ImageReservas" name="ImageReservas"
                                imageUrl={ofi.imageReservas}
                                addButtonProps={{
                                    color: "rose",
                                    round: true
                                }}
                                changeButtonProps={{
                                    color: "rose",
                                    round: true
                                }}
                                removeButtonProps={{
                                    color: "danger",
                                    round: true
                                }}
                            />
                        </Grid>
                        <Grid item xs={10} sm={5} lg={2}>
                            <br />
                            <p>Imagen Banner Reservas</p>
                            <ImageUpload
                                id="ImageBannerReservas" name="ImageBannerReservas"
                                imageUrl={ofi.imageBannerReservas}
                                addButtonProps={{
                                    color: "rose",
                                    round: true
                                }}
                                changeButtonProps={{
                                    color: "rose",
                                    round: true
                                }}
                                removeButtonProps={{
                                    color: "danger",
                                    round: true
                                }}
                            />
                        </Grid>
                        <Grid item xs={10} sm={5} lg={2}>
                            <br />
                            <p>Imagen Banner Encuestas</p>
                            <ImageUpload
                                id="ImageBannerEncuestas" name="ImageBannerEncuestas"
                                imageUrl={ofi.imageBannerEncuestas}
                                addButtonProps={{
                                    color: "rose",
                                    round: true
                                }}
                                changeButtonProps={{
                                    color: "rose",
                                    round: true
                                }}
                                removeButtonProps={{
                                    color: "danger",
                                    round: true
                                }}
                            />
                        </Grid>
                    </Grid>
                    <Grid container>
                        <Grid item xs={12} lg={12}>
                            <br />
                            <OthelloTitulo titulo="Configuracion Correo" />
                        </Grid>
                    </Grid>
                    <Grid container>
                        <Grid item xs={6} sm={3} lg={2}>
                            <OthelloEdit label="Descripcion" fieldname="descripcionCorreo" currentvalue={ofi.configEMailNotificaData != null ? ofi.configEMailNotificaData.descripcion : ""} />
                        </Grid>
                        <Grid item xs={6} sm={3} lg={2}>
                            <OthelloEdit label="DisplayName" fieldname="displayCorreo" currentvalue={ofi.configEMailNotificaData != null ? ofi.configEMailNotificaData.displayname : ""} />
                        </Grid>
                        <Grid item xs={6} sm={3} lg={1}>
                            <OthelloEdit label="EMail" fieldname="emailCorreo" currentvalue={ofi.configEMailNotificaData != null ? ofi.configEMailNotificaData.email : ""} />
                        </Grid>
                        <Grid item xs={6} sm={3} lg={1}>
                            <OthelloEdit label="MAILHOST" fieldname="mailhostCorreo" currentvalue={ofi.configEMailNotificaData != null ? ofi.configEMailNotificaData.mailhost : ""} />
                        </Grid>
                        <Grid item xs={6} sm={3} lg={1}>
                            <OthelloEdit label="MailUser" fieldname="mailuserCorreo" currentvalue={ofi.configEMailNotificaData != null ? ofi.configEMailNotificaData.mailUser : ""} />
                        </Grid>
                        <Grid item xs={6} sm={3} lg={1}>
                            <OthelloEdit label="MailPass" fieldname="mailpassCorreo" currentvalue={ofi.configEMailNotificaData != null ? ofi.configEMailNotificaData.mailPass : ""} />
                        </Grid>
                        <Grid item xs={6} sm={3} lg={1}>
                            <OthelloEdit label="Puerto" fieldname="puertoCorreo" currentvalue={ofi.configEMailNotificaData != null ? ofi.configEMailNotificaData.puerto : ""} />
                        </Grid>
                        <Grid item xs={6} sm={3} lg={1}>
                            <OthelloEdit label="SSL (S o N)" fieldname="sslCorreo" currentvalue={ofi.configEMailNotificaData != null ? ofi.configEMailNotificaData.ssl : ""} />
                        </Grid>
                    </Grid>

                    <Grid container>
                        <Grid item xs={12} lg={12}>
                            <br />
                            <OthelloTitulo titulo="Pasarela Pago" />
                        </Grid>
                    </Grid>
                    <Grid container>
                        <Grid item xs={6} sm={2}>
                            <OthelloEdit label="Codigo Cliente (Fuc), TCOD Paytef" fieldname="FucCliente" currentvalue={ofi.fucCliente} />
                        </Grid>
                        <Grid item xs={6} sm={2}>
                            <OthelloEdit label="Terminal - Cuenta AddOn" fieldname="TerminalCuenta" currentvalue={ofi.terminalCuenta} />
                        </Grid>
                        <Grid item xs={6} sm={2}>
                            <OthelloEdit label="Entorno (real=real o int=integracion)" fieldname="Entorno" currentvalue={ofi.entorno} />
                        </Grid>
                        <Grid item xs={6} sm={2}>
                            <OthelloEdit label="Moneda (RedSys=978, AddOn y PayComet ISO=EUR )" fieldname="Moneda" currentvalue={ofi.moneda} />
                        </Grid>
                        <Grid item xs={6} sm={2}>
                            <OthelloEdit label="Url Comercio" fieldname="UrlComercio" currentvalue={ofi.urlComercio} />
                        </Grid>
                        <Grid item xs={6} sm={2}>
                            <OthelloEdit label="Url Comercio After Pay" fieldname="UrlComercioAfterPay" currentvalue={ofi.urlComercioAfterPay} />
                        </Grid>
                    </Grid>
                    <Grid container>
                        <Grid item xs={12} sm={2}>
                            <OthelloEdit label="Cryptografia (RedSys = HMAC_SHA256_V1, AddOn y PayComet = '')" fieldname="Cryptografia" currentvalue={ofi.cryptografia} />
                        </Grid>
                        <Grid item xs={12} sm={3}>
                            <OthelloEdit label="Licencia (MainKeyRedSys - Dado por Redsys) o Usuario Paytef" fieldname="LicenciaRedSys" currentvalue={ofi.licenciaRedSys} />
                        </Grid>                       
                        <Grid item xs={12} sm={2}>
                            <OthelloEdit label="Password PayComet/Paytef" fieldname="PasswordComet" currentvalue={ofi.passwordComet} />
                        </Grid>
                        <Grid item xs={12} sm={2}>
                            <OthelloEdit label="Modo Seguro PayComet (Si=1, No=0)" fieldname="ModoSeguroComet" currentvalue={ofi.modoSeguroComet} />
                        </Grid>
                        <Grid item xs={12} sm={2}>
                            <OthelloEdit label="Clave Secreta Compartida AddOn" fieldname="SecretoCompartidoAddOn" currentvalue={ofi.secretoCompartidoAddOn} />
                        </Grid>
                    </Grid>
                    <Grid container>
                        <Grid item xs={12} lg={12}>
                            <br />
                            <OthelloTitulo titulo="Configuracion Cerradura" />
                        </Grid>
                    </Grid>
                    <Grid container>
                        <Grid item xs={6} sm={2} lg={1}>
                            <OthelloComboBox label='Modelo' fieldname="modeloCerradura" items={TiposModeloCerradura} currentvalue={ofi.configCerraduraData != null ? ofi.configCerraduraData.modelo : 0} />
                        </Grid>
                        <Grid item xs={6} sm={3} lg={2}>
                            <OthelloEdit label="Descripcion" fieldname="descripcionCerradura" currentvalue={ofi.configCerraduraData != null ? ofi.configCerraduraData.descripcion : ""} />
                        </Grid>
                        <Grid item xs={6} sm={3} lg={2}>
                            <OthelloEdit label="Usuario" fieldname="cerraduraUser" currentvalue={ofi.configCerraduraData != null ? ofi.configCerraduraData.cerraduraUser : ""} />
                        </Grid>
                        <Grid item xs={6} sm={3} lg={1}>
                            <OthelloEdit label="Password" fieldname="cerraduraPass" currentvalue={ofi.configCerraduraData != null ? ofi.configCerraduraData.cerraduraPass : ""} />
                        </Grid>     
                        <Grid item xs={6} sm={3} lg={2}>
                            <OthelloEdit label="Url ALternativa" fieldname="cerraduraUrlALternativa" currentvalue={ofi.configCerraduraData != null ? ofi.configCerraduraData.cerraduraUrlALternativa : ""} />
                        </Grid>     
                    </Grid>
                    <Grid container>
                        <Grid item xs={12} lg={12}>
                            <br />
                            <OthelloTitulo titulo="Version" />
                        </Grid>
                    </Grid>
                    <Grid container>
                        <input id="updatear" name="updatearAux" type="hidden" value={ofi.updatear} />
                        <Grid item xs={6} sm={6} sm={3}>
                            <OthelloEdit label="Version" fieldname="bdversionAux" currentvalue={(ofi.version != null ? ofi.version.bdversion : 0)} />
                        </Grid>
                        <Grid item xs={6} sm={6} sm={3}>
                            <OthelloEdit label="Nombre BD" fieldname="bdnameAux" currentvalue={(ofi.version != null ? ofi.version.bdname : "")} />
                        </Grid>
                    </Grid>
                </form>
            );
        }
        else
            return "";
    }


    let formulario = loading ? <p><CircularProgress color="secondary" /></p> : renderFormOficina(dataoficina);

    let NombreOficina = dataoficina != null && dataoficina.id_Oficina > 0 ? (dataoficina.tipoOfi == 3 ? "Plataforma " : "Oficina ") + dataoficina.nombreOficina : "Nueva Oficina";

    let alerta = alert != null ? <OthelloPopUpResult titulo="" alert={alert} onClosePopUpResult={onClosePopUpResult} /> : "";

    let extras = [];

    if (idRol == Roles.SuperUsuario) {
        extras = [{ id: "volcaroficina", icon: InsertDriveFile, texto: "Actualizar", permiso: "OP_xxx" },
            { id: "volcaroficinaconupdate", icon: InsertDriveFile, texto: "Actualizar +1", permiso: "OP_xxx" },
        ];
    }

    return (
        <Grid container>
            <Grid item xs={12} sm={12} md={12}>
                {alerta}
            </Grid>
            <Grid item xs={12}>
                <OthelloTituloPanelData titulo={NombreOficina} margentop={0}>
                    {/*<div color="rose" icon>*/}
                    {/*    <div color="rose">*/}
                    {/*        <BusinessCenter />*/}
                    {/*    </div>*/}
                    {/*    <h4>{NombreOficina}</h4>*/}
                    {/*</div>*/}
                    <div style={{ backgroundColor: '#FFFFFF' }}>
                        <Grid container>
                            <Grid item xs={12} >
                                {
                                    idRol == Roles.SuperUsuario ? <OthelloBotonera statePage={statePage} onNuevo={nuevoDataPage} onGrabar={grabarDataPage} onDeshacer={deshacerDataPage} forzarnuevo={true} onKeydown={keyDownDataPage} arrayBotonesExtras={extras}/> :
                                        <OthelloBotonera statePage={statePage} onGrabar={grabarDataPage} onDeshacer={deshacerDataPage} forzarnuevo={true} />
                                }                               
                            </Grid>
                        </Grid>
                        <Grid container>
                            <Grid item xs={12} >
                                {formulario}
                            </Grid>
                        </Grid>
                    </div>
                </OthelloTituloPanelData>
            </Grid>
        </Grid>
    );
}
